<template>
    <div class="-m-5 md:m-0 h-full flex-1 overflow-hidden">
        <tabulator
            :columns="columns"
            ajax-path="unifi/clients"
            :ajax-params="ajaxParams"
        />
    </div>
</template>

<script>
    export default {
        props: {
            site: {
                type: String,
                default: null,
            }
        },
        data() {
            return {
                ajaxParams: {},
                columns: [
                    {
                        title: 'Name',
                        field: 'hostname',
                        sorter: 'string',
                        minWidth: 250,
                        formatter({_cell}) {
                            if (_cell.value) {
                                return _cell.value;
                            }

                            return _cell.row.data.mac;
                        }
                    },
                    {
                        title: 'MAC Address',
                        field: 'mac',
                        sorter: 'string',
                        minWidth: 200,
                    },
                    {
                        title: 'IP Address',
                        field: 'ip',
                        sorter: 'string',
                        minWidth: 200,
                    },
                    {
                        title: 'Connection',
                        field: 'essid',
                        sorter: 'string',
                        minWidth: 150,
                        formatter({_cell}) {
                            if (_cell.value) {
                                return _cell.value;
                            }

                            return _cell.row.data.network;
                        }
                    },
                    {
                        title: 'Uptime',
                        minWidth: 150,
                        formatter({_cell}) {
                            let pad = function (num, size) { return ('000' + num).slice(size * -1); };
                            let time = _cell.row.data.uptime;
                            let days = Math.floor(time / 60 / 60 / 24);
                            let hours = Math.floor(time / 60 / 60);
                            let minutes = Math.floor(time / 60) % 60;
                            let seconds = Math.floor(time - minutes * 60);
                            
                            return pad(days, 2) + 'd ' + pad(hours, 2) + 'h ' + pad(minutes, 2) + 'm ' + pad(seconds, 2) + 's';
                        }
                    }
                ],
            }
        },
        mounted() {
            this.ajaxParams = {
                site: this.site,
            }
        }
    }
</script>